<template>
    <div style="display:flex;flex-flow:row;" v-if="showNode">
        <div style="display:flex;width:34px;height:34px;align-items: center;justify-content: center;">
            <span style="cursor:pointer;" class="glyphicon"
                :class="{ 'glyphicon-triangle-right': !showChild, 'glyphicon-triangle-bottom': showChild }"
                @click="expandClick" v-if="hasChilds"></span>
                <span v-else class="glyphicon glyphicon-hand-right"></span>
        </div>
        <div v-if="showCheckbox"
            style="display:flex; width:34px;height:34px;align-items: center;justify-content: center;border-left:1px solid white;">
            <span style="display:flex; align-items: center;justify-content: center;"
                @click="catClicked({ child: catNode, parent: parentNode })" class="glyphicon"
                :class="{ 'glyphicon-unchecked': !(isAllowed), 'glyphicon-check': isAllowed }"></span>
        </div>
        <slot></slot>
        <span
            style="flex:1;display: flex;height:34px; align-items: center;justify-content: center;cursor: pointer;padding-left:16px;padding-right:16px;cursor: pointer;"
            @click="catClicked({ child: catNode, parent: parentNode })">{{ catNode.name }}</span>
    </div>
</template>
<script>

export default {
    props: {
        catNode:{type:Object},
        parentNode:{type:Object},
        showChild:{type:Boolean},
        hasChilds:{type:Boolean},
        showNode:{type:Boolean},
        isAllowed:{type:Boolean},
        showCheckbox:{type:Boolean}
    },
    computed: {
        
    },
    data: function () {
        return {
            
        };
    },
    methods: {
        expandClick(){
            this.$emit("expandClick");
        },
        catClicked(catPair) {
            this.$emit("catClicked", catPair);
        }
    },
    watch: {
       
    },
    created: function () {
        
    },
    mounted: function () {
        
    },
    destroyed: function () {

    }
}
</script>